import { push } from 'modules/gtm/modules/common';
import { IFilter } from 'commerce/factFinder/types';

type FilterEvent = {
  event_name: string;
  value?: string | number;
  event_action: string;
};

type FilterTypes = Record<string, FilterEvent | FilterEvent[]>;

type FilterData = {
  type: string;
  value: string | number | Array<string | number>;
};

const filterTypes: FilterTypes = {
  ratingScore: [
    {
      event_name: 'filter_rating',
      event_action: 'rating',
    },
  ],
  priceValue: [
    {
      event_name: 'filter_price_min',
      event_action: 'price min',
    },
    {
      event_name: 'filter_price_max',
      event_action: 'price max',
    },
  ],
  colors: {
    event_name: 'filter_color',
    event_action: 'color',
  },
  brand: {
    event_name: 'filter_brand',
    event_action: 'brand',
  },
  genders: {
    event_name: 'filter_sexual_orientation',
    event_action: 'sexual orientation',
  },
  materials: {
    event_name: 'filter_material',
    event_action: 'material',
  },
  size: {
    event_name: 'filter_size',
    event_action: 'size',
  },
  tags: {
    event_name: 'filter_tags',
    event_action: 'tags',
  },
  type: {
    event_name: 'filter_type',
    event_action: 'type',
  },
};

export const parseFilters = (appliedFilters: IFilter[]) => {
  return appliedFilters
    .flatMap((appliedFilter) => {
      const { type, value } = appliedFilter as FilterData;
      const filterConfig = filterTypes[type];

      if (!filterConfig) {
        return null;
      }

      if (Array.isArray(value)) {
        return value.map((val, i) => {
          const config = Array.isArray(filterConfig)
            ? filterConfig[i]
            : filterConfig;

          return {
            ...config,
            value: val,
          };
        });
      } else {
        const config = Array.isArray(filterConfig)
          ? filterConfig[0]
          : filterConfig;

        return {
          ...config,
          value,
        };
      }
    })
    .filter(Boolean);
};

export const gtmPushFilters = (appliedFilters: IFilter[]): void => {
  const parsedFilters = parseFilters(appliedFilters) as FilterEvent[];

  parsedFilters.forEach(gtmPushFilter);
};

export const gtmPushFilter = ({
  event_name,
  value,
  event_action,
}: FilterEvent) => {
  push({
    event: 'Generic Event',
    event_name,
    [event_name]: {
      filter_element: value,
      event_category: 'filter',
      event_action,
      event_label: value,
    },
  });
};
